
import axios from 'axios';
import Session from '../support/Session';
import ItemContract from '../contracts/Item';
import Product from './Product';
import Resource from './Resource';
import Photo from "./Photo";

/**
 * Item class
 * @class
 **/
class Item extends Resource implements ItemContract
{
    /**
     * Resource identifier
     * @type {String}
     **/
    static handle = 'item_id';

    /**
     * Default attributes
     * @type {Object}
     **/
    static attributes: ItemContract = {
        item_id: null,
        photo_id: null,
        product_version_id: null,
        quantity: 1,
    };

    /**
     * Resource relations
     * @type {Object}
     **/
    static relations = {
        photo: {
            related: Photo,
            default: null,
        },
        product: {
            related: Product,
            default: null,
        },
    };

    /**
     * Resource attributes
     * @type {ItemContract}
     **/
    attributes: ItemContract;

    /**
     * Current attributes
     **/
    readonly item_id: number;
    photo_id: number;
    product_version_id: number;
    quantity: number;

    /**
     * Resource relationships
     */
    photo: Photo;
    product: Product;


    /**
     * Get total cost
     * @return {Number}
     */
    get total(): number
    {
        return this.quantity * this.product.price;
    }


    /**
     * Get total weight
     * @return {Number}
     */
    get weight(): number
    {
        return this.quantity * this.product.weight;
    }


    /**
     * Save item
     * @return {Promise<Item>}
     */
    save(): Promise<Item>
    {
        if( ! this.changed )
            return null;

        const basket = Session.basket;

        basket.saving = true;
        return axios.patch( `/api/basket/${ basket.basket_id }`, { item_id: this.attributes.item_id, ...this.changes } ).then( response => {
            this.sync( response.data );
            basket.saving = false;

            return this as Item;
        });
    }
}

Resource.register( Item );

export default Item;
